// Utility functions for user-specific localStorage
export const getUserStorageKey = (key) => {
  const accountId = localStorage.getItem("accountId");
  return accountId ? `${key}_${accountId}` : key;
};

export const getUserFormKey = (itemId) => {
  return getUserStorageKey(`form_${itemId}`);
};

export const getUserStatusKey = (itemId) => {
  return getUserStorageKey(`status_${itemId}`);
};

export const getUserStorageItem = (key) => {
  const userKey = getUserStorageKey(key);
  return localStorage.getItem(userKey);
};

export const setUserStorageItem = (key, value) => {
  const userKey = getUserStorageKey(key);
  localStorage.setItem(userKey, value);
};

export const removeUserStorageItem = (key) => {
  const userKey = getUserStorageKey(key);
  localStorage.removeItem(userKey);
};

export const clearUserStorage = () => {
  const accountId = localStorage.getItem("accountId");
  if (!accountId) return;
  
  // Remove all user-specific keys
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.startsWith(`form_${accountId}_`) || 
      key.startsWith(`status_${accountId}_`) ||
      key.startsWith(`uploadedDocs_${accountId}`) ||
      key.startsWith(`taxFormData_${accountId}`) ||
      key === "whmis_unlockedModules" ||
      key === "whmis_selectedAnswers" ||
      key === "whmis_currentModule" ||
      key === "whmis_quizIndex"
    )) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
};
